import Rails from '@rails/ujs'
import '@hotwired/turbo-rails'
import './vendor/jQuery'
import './vendor/bootstrap'
import './vendor/bootstrap-formhelpers.min.js'
import './vendor/bootstrap-formhelpers-phone.js'
import 'bootstrap-datepicker'
import './vendor/select2'
import './onload'

Rails.start()
